import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import CampaigncenterEditForm from './CampaigncenterEditForm';
import CampaigncenterList from './CampaigncenterList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import CampaigncenterListView from './CampaigncenterListView'


export default function CampaigncenterDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.campaigncenterDashboard);
  const [ campaigncenterId, setCampaigncenterId] = React.useState('');
  const [reloadCampaigncenterList, setReloadCampaigncenterList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <CampaigncenterEditForm 
            setReloadCampaigncenterList={setReloadCampaigncenterList}
            campaigncenterId={campaigncenterId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <CampaigncenterListView 
                      setCampaigncenterId = {setCampaigncenterId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
